import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import bus from '@/bus'
import snacks from '@/services/snacks'
import { OrderStatus } from "./models/Order";
import { DishStatus } from "./models/Dish";

const instance = axios.create({
  headers: {
    "Content-Type": "application/json; charset=utf-8"
  },
  baseURL: process.env.VUE_APP_API_URL
});

function createErrorInterceptor() {
  const id = instance.interceptors.response.use(
    response => response,
    error => {
      if (error instanceof Error) {
        // @ts-ignore
        const response = error.response;
        let msg = error.message;
        if (response) {
          if (response.data) {
            msg = response.data;
            if (response.data.title) {
              msg = response.data.title;
            }
          }
          if (response.status >= 500) {
            bus.$emit("app.exception-dialog.show", msg);
          } else {
            snacks.error(msg);
          }
        } else {
          snacks.error(msg);
        }
      }
    }
  );
}

/*
if (process.env.VUE_APP_AXIOS_MOCK_ENABLED) {
  var mock = new MockAdapter(instance);

  mock
    .onPost("orders")
    .reply(200, {
      items: [
        {
          id: "1",
          date: new Date(),
          readyForDelivery: new Date(),
          status: OrderStatus.Pending,
          customer: {
            id: "1",
            firstName: "Herbert",
            lastName: "Karajan",
            phone: "0512 206567"
          },
          items: [
            {
              id: 1,
              quantity: 1,
              title: "Holzfäller Schnitzelpfanne",
              price: 9.9
            },
            {
              id: 2,
              quantity: 2,
              title: "Dose Cola",
              price: 3.3
            }
          ]
        }
      ],
      totalItems: 1
    })

    .onGet("orders/1")
    .reply(200, {
      id: "1",
      date: new Date(),
      readyForDelivery: new Date(),
      status: OrderStatus.Pending,
      restaurant: {
        name: "Schnitzelparadies"
      },
      customer: {
        id: "1",
        firstName: "Herbert",
        lastName: "Karajan",
        phone: "0512 206567"
      },
      items: [
        {
          id: 1,
          quantity: 1,
          title: "Holzfäller Schnitzelpfanne",
          price: 9.9
        },
        {
          id: 2,
          quantity: 2,
          title: "Dose Cola",
          price: 3.3
        }
      ]
    })

    .onPost("dishCategories")
    .reply(200, {
      items: [
        {
          id: "1",
          title: "Tiroler Spezialitäten",
          numActive: 5,
          numInactive: 1,
          dishes: [
            {
              id: 1,
              quantity: 1,
              title: "Holzfäller Schnitzelpfanne",
              price: 9.9
            },
            {
              id: 2,
              quantity: 2,
              title: "Dose Cola",
              price: 3.3
            }
          ]
        },
        {
          id: "2",
          title: "Suppen",
          numActive: 8,
          numInactive: 0,
          dishes: [
            {
              id: 1,
              title: "Sudelnupppe",
              status: DishStatus.Available
            },
            {
              id: 2,
              title: "Dose Cola",
              status: DishStatus.Available
            }
          ]
        }
      ],
      totalItems: 1
    })

    .onPost("dishes", { categoryId: "1" })
    .reply(200, {
      items: [
        {
          id: 1,
          title: "Holzfäller Schnitzelpfanne",
          status: DishStatus.Available
        },
        {
          id: 2,
          title: "Dose Cola",
          status: DishStatus.CurrentlyUnavailable
        }
      ],
      totalItems: 1
    })

    .onAny()
    .passThrough();
}
*/

createErrorInterceptor();

export default instance;
